import { useState, useEffect, useContext, useRef } from 'react';
import HeaderBanner from '../sub-components/HeaderBanner.tsx';
import Footer from "../sub-components/Footer.tsx";
import InputDataTable from '../sub-components/InputDataTableCopy.jsx';
import PageContext from '../sub-components/PageContext';
import { HttpContext } from '../../api-services/HttpService';
import { useSelector, useDispatch } from "react-redux";
import { bindActionCreators } from 'redux';
import { actionCreators } from "../../redux/index";
import PageInput from '../sub-components/PageInputCopy.jsx';
import PageDropdown from '../sub-components/PageDropdownWithIdObjCopy.jsx';
import CircularProgress from '@mui/material/CircularProgress';
// import ApiRequestButton from '../sub-components/ApiRequestButton';
import AddConsortiumGroupRow from '../sub-components/AddConsortiumGroupRow';
import isAlphaNumeric from '../functions/isAlphaNumeric';
import SnackbarAlert from '../sub-components/SnackbarAlert';
import { AuthContext } from '../../auth/AuthRoute';
import copyObjectToArray from '../functions/copyObjectToArray';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import AddConsortiumRebateSetupRow from '../sub-components/AddConsortiumRebateSetupRow';
import AddGroupRebateSetupRow from '../sub-components/AddGroupRebateSetupRow';
import { Link } from 'react-router-dom';
import applyFilters from '../functions/applyFilters.js';
import standardFilter from '../functions/standardFilter.js';
import RebateComponentInput from '../sub-components/RebateComponentInput.jsx';
import validateInputArrayDynamic from '../functions/validateInputArray.js';
import dynamicValidation from '../functions/dynamicValidation.js';
import dynamicTransformation from '../functions/dynamicTransformation.js';
import PageBreadcrumbs from '../sub-components/PageBreadcrumbs.jsx';
import ButtonComponent from '../sub-components/ButtonComponent.jsx';
import { Typography } from '@mui/material';

const ConsortiumManagementPage = () => {
    // initialize http context 
    const {
        GET,
        POST,
    } = useContext(HttpContext);
    // initialize auth context
    const {
        getAdmin,
        getDataTech,
    } = useContext(AuthContext);
    // redux state for use of persistant state in different route (CompanyDetailsPage)
    const consortiumId = useSelector((state) => state.consortiumId);
    const backPath = useSelector((state) => state.backPath);
    const dispatch = useDispatch();
    const { setConsortiumId, setBackPath } = bindActionCreators(actionCreators, dispatch);
    // initialize state
    const [consortium, setConsortium] = useState('');
    const [portfolioId, setPortfolioId] = useState();
    const [portfolioIdList, setPortfolioIdList] = useState([]);
    const [payoutType, setPayoutType] = useState();
    const [payoutTypeList, setPayoutTypeList] = useState([]);
    const [editButtonBool, setEditButtonBool] = useState(false);
    const [showSpinner, setShowSpinner] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    // intiailize table state for group 
    const [groupDataList, setGroupDataList] = useState([]);
    const [showGroupDataList, setShowGroupDataList] = useState([]);
    const [groupDateListLength, setGroupDataListLength] = useState(0);
    const [groupTableHeader, setGroupTableHeader] = useState([]);
    const [addGroup, setAddGroup] = useState(false);
    const [dummyDataList, setDummyDataList] = useState([]);
    // initialize state for group rebate setups 
    const [groupSetupDataList, setGroupSetupDataList] = useState([]);
    const [showGroupSetupDataList, setShowGroupSetupDataList] = useState([]);
    const [groupSetupDataListLength, setGroupSetupDataListLength] = useState(0);
    const [groupSetupTableHeader, setGroupSetupTableHeader] = useState([]);
    const [dummySetupDataList, setDummySetupDataList] = useState([]);
    // initialize table state for rebate setups 
    const [rebateSetupDataList, setRebateSetupDataList] = useState({});
    const [rebateSetupDataListLength, setRebateSetupDataListLength] = useState(0);
    const [rebateSetupTableHeader, setRebateSetupTableHeader] = useState([]);
    // initialize state for rebate input type to determine incentiverate transformations
    const [rebateInputTypeId, setRebateInputTypeId] = useState(0);
    // initialize lists for rebate setups 
    const [activeList, setActiveList] = useState([{ label: 'Active', id: "true" }, { label: 'Inactive', id: "false" }])
    const [feeCategoryList, setFeeCategoryList] = useState([]);
    const [productTypeList, setProductTypeList] = useState([]);
    const [billingRateList, setBillingRateList] = useState([]);
    const [rebateSetupTypeList, setRebateSetupTypeList] = useState([]);
    // initialize state for group context
    const [achAccountTypeList, setAchAccountTypeList] = useState([]);
    const [payoutMethodList, setPayoutMethodList] = useState([]);
    // initialize snackbar state
    const [showSnackbar, setShowSnackbar] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarColor, setSnackbarColor] = useState('info');
    // initialize state for error
    const [consortiumIdError, setConsortiumIdError] = useState(false);
    const [portfolioIdError, setPortfolioIdError] = useState(false);
    const [payoutTypeError, setPayoutTypeError] = useState(false);
    // initialize state array for error
    const [consortiumGroupErrorList, setConsortiumGroupErrorList] = useState([{}]);
    const [rebateSetupErrorList, setRebateSetupErrorList] = useState([{}]);
    const [groupSetupErrorList, setGroupSetupErrorList] = useState([{}]);
    const [consortiumRebateComponentErrorList, setConsortiumRebateComponentErrorList] = useState([{}]);
    const [groupRebateComponentErrorList, setGroupRebateComponentErrorList] = useState([{}]);
    // initialize stat for rebate components 
    const [rebateComponentConfig, setRebateComponentConfig] = useState([]);
    const [fullRebateComponentConfig, setFullRebateComponentConfig] = useState([]);
    const [consortiumRebateComponents, setConsortiumRebateComponents] = useState({});
    const [groupRebateComponents, setGroupRebateComponents] = useState({});
    // initialise state for dynamic input tables 
    const [consortiumRebateSetupConfig, setConsortiumRebateSetupConfig] = useState([]);
    const [consortiumRebateSetupLists, setConsortiumRebateSetupLists] = useState({
        active: [{ label: '--select--', id: '--select--' }, { label: 'Active', id: "true" }, { label: 'Inactive', id: "false" }],
        billingrateid: [{ label: '--select--', id: '--select--' }],
        producttypeid: [{ label: '--select--', id: '--select--' }],
        feecategoryid: [{ label: '--select--', id: '--select--' }],
        rebatesetuptypeid: [{ label: '--select--', id: '--select--' }]
    });
    const [groupConfig, setGroupConfig] = useState([]);
    const [groupLists, setGroupLists] = useState({
        active: [{ label: '--select--', id: '--select--' }, { label: 'Active', id: "true" }, { label: 'Inactive', id: "false" }],
        payoutmethodid: [{ label: '--select--', id: '--select--' }],
        achaccounttype: [{ label: '--select--', id: '--select--' }]
    });
    const [groupRebateSetupConfig, setGroupRebateSetupConfig] = useState([]);
    const [groupRebateSetupLists, setGroupRebateSetupLists] = useState({
        active: [{ label: '--select--', id: '--select--' }, { label: 'Active', id: "true" }, { label: 'Inactive', id: "false" }],
        billingrateid: [{ label: '--select--', id: '--select--' }],
        producttypeid: [{ label: '--select--', id: '--select--' }],
        feecategoryid: [{ label: '--select--', id: '--select--' }],
        rebatesetuptypeid: [{ label: '--select--', id: '--select--' }]
    });
    // refs to determine initial render
    const initialRender1 = useRef(true);

    // wrap component in function to pass to table
    const GroupRowComponent = (row, count, tableHeader) => {
        return <AddConsortiumGroupRow row={row} count={count} tableHeader={tableHeader} />
    }

    // wrap component in function to pass to table 
    const GroupSetupRowComponent = (row, count, tableHeader) => {
        return <AddGroupRebateSetupRow row={row} count={count} tableHeader={tableHeader} />
    }

    // wrap component in function to pass to table 
    const RebateSetupRowComponent = (row, count, tableHeader) => {
        return <AddConsortiumRebateSetupRow row={row} count={count} tableHeader={tableHeader} />
    }

    // function to set snackbar state
    const snackbarAlert = (show, message, color) => {
        setSnackbarMessage(snackbarMessage => snackbarMessage = message);
        setSnackbarColor(snackbarColor => snackbarColor = color);
        setShowSnackbar(showSnackbar => showSnackbar = show);
    }

    // event handler for submit click 
    const onSubmitClick = () => {
        // validate consortium data points 
        if (!isAlphaNumeric(consortium, true)) {
            snackbarAlert(true, 'Error: Invalid Consortium ID.', 'error');
            setConsortiumIdError(consortiumIdError => consortiumIdError = true);
            return;
        }
        else {
            setConsortiumIdError(consortiumIdError => consortiumIdError = false);
        }
        if (!portfolioIdList.includes(portfolioId)) {
            snackbarAlert(true, 'Error: Invalid Consortium Type.', 'error');
            setPortfolioIdError(portfolioIdError => portfolioIdError = true);
            return;
        }
        else {
            setPortfolioIdError(portfolioIdError => portfolioIdError = false);
        }
        if (!payoutTypeList.includes(payoutType)) {
            snackbarAlert(true, 'Error: Invalid Payout Type', 'error');
            setPayoutTypeError(payoutTypeError => payoutTypeError = true);
            return;
        }
        else {
            setPayoutTypeError(payoutTypeError => payoutTypeError = false);
        }

        // validate rebate setups 
        let rebateSetupDataListRequest = copyObjectToArray(rebateSetupDataList);
        // remove blank column 
        rebateSetupDataListRequest = rebateSetupDataListRequest.slice(0, rebateSetupDataListRequest.length - 1);
        // validate array
        let checkError = validateInputArrayDynamic(
            rebateSetupDataListRequest,
            consortiumRebateSetupConfig,
            dynamicValidation,
            consortiumRebateSetupLists,
            snackbarAlert,
            rebateSetupErrorList,
            setRebateSetupErrorList,
            dynamicTransformation,
            {
                incentiverate: {
                    rateTypeId: rebateInputTypeId,
                }
            }
        );
        // don't run request if error
        if (checkError) {
            return;
        }

        // validate consortium rebate components
        let consortiumRebateComponentsRequest = [{ ...consortiumRebateComponents }];
        checkError = false;
        checkError = validateInputArrayDynamic(
            consortiumRebateComponentsRequest,
            rebateComponentConfig,
            dynamicValidation,
            {},
            snackbarAlert,
            consortiumRebateComponentErrorList,
            setConsortiumRebateComponentErrorList,
            dynamicTransformation,
            {}
        );
        // don't run request if error
        if (checkError) {
            return;
        }

        // validate group id 
        let groupDataListRequest = [];
        let groupSetupDataListRequest = [];
        let groupRebateComponentsRequest = [{ ...groupRebateComponents }];
        if (addGroup) {

            // copy group object to array
            groupDataListRequest = copyObjectToArray(groupDataList);
            // validate array 
            checkError = false;
            checkError = validateInputArrayDynamic(
                groupDataListRequest,
                groupConfig,
                dynamicValidation,
                groupLists,
                snackbarAlert,
                consortiumGroupErrorList,
                setConsortiumGroupErrorList,
                dynamicTransformation,
                {
                    achaccountnumber: {
                        clearachinfo: groupDataList[0]['clearachinfo']
                    },
                    achbankabanumber: {
                        clearachinfo: groupDataList[0]['clearachinfo']
                    },
                    achaccounttype: {
                        clearachinfo: groupDataList[0]['clearachinfo']
                    }
                }
            );
            // don't run request if error
            if (checkError) {
                return;
            }

            // copy input object to an array
            groupSetupDataListRequest = copyObjectToArray(groupSetupDataList);
            // remove blank element 
            groupSetupDataListRequest = groupSetupDataListRequest.slice(0, groupSetupDataListRequest.length - 1);
            // check all rows of group setup input
            checkError = false;
            checkError = validateInputArrayDynamic(
                groupSetupDataListRequest,
                groupRebateSetupConfig,
                dynamicValidation,
                groupRebateSetupLists,
                snackbarAlert,
                groupSetupErrorList,
                setGroupSetupErrorList,
                dynamicTransformation,
                {
                    incentiverate: {
                        rateTypeId: rebateInputTypeId,
                    }
                }
            );
            // don't run request if error
            if (checkError) {
                return;
            }

            // validate consortium rebate components
            checkError = false;
            checkError = validateInputArrayDynamic(
                groupRebateComponentsRequest,
                rebateComponentConfig,
                dynamicValidation,
                {},
                snackbarAlert,
                groupRebateComponentErrorList,
                setGroupRebateComponentErrorList,
                dynamicTransformation,
                {}
            );
            // don't run request if error
            if (checkError) {
                return;
            }

        }
        // add consortium id level data to args object
        let consortiumIdData = [{
            consortiumid: consortium,
            incentiveid: portfolioId['id'], // take id of dropdown field
            payouttypeid: payoutType['id'], // take id of dropdown field
            addgroup: addGroup,
        }];
        // use HttpContext to make request
        setIsLoading(isLoading => isLoading = true);
        POST('/consortium/addConsortiumIdPage', {
            ConsortiumIdData: consortiumIdData,
            RebateSetupDataList: rebateSetupDataListRequest,
            GroupDataList: groupDataListRequest,
            GroupSetupDataList: groupSetupDataListRequest,
            ConsortiumRebateComponents: consortiumRebateComponentsRequest[0],
            GroupRebateComponents: groupRebateComponentsRequest[0]
        }).then(res => {
            console.log(res);
            // trigger success alert
            snackbarAlert(true, 'Successfully uploaded data.', 'success');
            // hide spinner
            setIsLoading(isLoading => isLoading = false);
            // update redux persistant state and redirect to /CompanyDetailsPage
            setConsortiumId(consortium);
            setBackPath('/consortiumSearchPage');
            window.location = window.location.origin + '/ConsortiumManagementPage'
        }).catch(err => {
            console.log(err);
            // show alert on error
            snackbarAlert(true, 'Error uploading data.', 'error');
            // hide spinner
            setIsLoading(isLoading => isLoading = false);
        });
    }

    // function to retrieve page data via api
    const getAddConsortiumIdData = () => {
        setShowSpinner(showSpinner => showSpinner = true);
        return new Promise((resolve, reject) => {
            GET('/consortium/addConsortiumIdPage', {}).then(res => {
                // set state 
                setPortfolioIdList(portfolioIdList => portfolioIdList = res['data']['PortfolioList']);
                // set group table state 
                setGroupTableHeader(groupTableHeader => groupTableHeader = res['data']['ConsortiumGroupTableHeader']);
                let temp = [];
                for (let i = 0; i < res['data']['ConsortiumGroupTableHeader'].length; i++) {
                    temp.push(res['data']['ConsortiumGroupTableHeader'][i]['columnname']);
                }
                let temp1;
                // add first element to data list. For group only one element is expected
                [...temp].map((el) => {
                    if (el === 'startdate') {
                        temp1 = { ...temp1, [el]: new Date() };
                    }
                    else if (el === 'enddate') {
                        temp1 = { ...temp1, [el]: null };
                    }
                    else if (el === 'active') {
                        temp1 = { ...temp1, [el]: activeList[0] }
                    }
                    else {
                        temp1 = { ...temp1, [el]: '' };
                    }
                });
                setGroupDataList(groupDataList => groupDataList = { 0: temp1 });
                // set rebate setup table state
                setRebateSetupTableHeader(rebateSetupTableHeader => rebateSetupTableHeader = res['data']['RebateSetupsTableHeader']);
                temp = [];
                for (let i = 0; i < res['data']['RebateSetupsTableHeader'].length; i++) {
                    temp.push(res['data']['RebateSetupsTableHeader'][i]['columnname']);
                }
                // add first element to data list 
                let temp2;
                [...temp].map((el) => {
                    if (el == 'blank') {
                        temp2 = { ...temp2, [el]: true };
                    }
                    else {
                        temp2 = { ...temp2, [el]: '' };
                    }
                });
                setRebateSetupDataList(rebateSetupDataList => rebateSetupDataList = { 0: temp2 });
                // set payoutmethodid list for group payout info 
                setPayoutMethodList(payoutMethodList => payoutMethodList = res['data']['PayoutMethodList']);
                // ach account type list for group payout info 
                setAchAccountTypeList(achAccountTypeList => achAccountTypeList = res['data']['AchAccountTypeList']);
                // set lists for rebate setups 
                setFeeCategoryList(feeCategoryList => feeCategoryList = res['data']['FeeCategoryList']);
                setProductTypeList(productTypeList => productTypeList = res['data']['ProductTypeList']);
                setBillingRateList(billingRateList => billingRateList = res['data']['BillingRateList']);
                // set input type ID for incentive rate 
                setRebateInputTypeId(rebateInputTypeId => rebateInputTypeId = res['data']['RebateInputTypeId']);
                // set payout type list 
                setPayoutTypeList(payoutTypeList => payoutTypeList = res['data']['PayoutTypeList']);
                // group rebate setup table state 
                setGroupSetupTableHeader(groupSetupTableHeader => groupSetupTableHeader = res['data']['GroupSetupTableHeader']);
                temp = [];
                for (let i = 0; i < res['data']['GroupSetupTableHeader'].length; i++) {
                    temp.push(res['data']['GroupSetupTableHeader'][i]['columnname']);
                }
                // add first element to data list 
                let temp3;
                [...temp].map((el) => {
                    if (el == 'blank') {
                        temp3 = { ...temp2, [el]: true };
                    }
                    else {
                        temp3 = { ...temp2, [el]: '' };
                    }
                });
                setGroupSetupDataList(groupSetupDataList => groupSetupDataList = { 0: temp3 });
                // set rebate setup type list 
                setRebateSetupTypeList(rebateSetupTypeList => rebateSetupTypeList = res['data']['RebateSetupTypeList']);
                // get data for all rebate component configs 
                setFullRebateComponentConfig(fullRebateComponentConfig => fullRebateComponentConfig = res['data']['RebateComponentConfigs']);
                // set configs for dynamic input tables 
                setConsortiumRebateSetupConfig(consortiumRebateSetupConfig => consortiumRebateSetupConfig = res['data']['ConsortiumRebateSetupConfig']);
                setConsortiumRebateSetupLists(consortiumRebateSetupLists => consortiumRebateSetupLists = {
                    active: activeList,
                    billingrateid: res['data']['BillingRateList'],
                    producttypeid: res['data']['ProductTypeList'],
                    feecategoryid: res['data']['FeeCategoryList'],
                    rebatesetuptypeid: res['data']['RebateSetupTypeList']
                });
                setGroupConfig(groupConfig => groupConfig = res['data']['GroupConfig']);
                setGroupLists(groupLists => groupLists = {
                    active: activeList,
                    payoutmethodid: res['data']['PayoutMethodList'],
                    achaccounttype: res['data']['AchAccountTypeList']
                });
                setGroupRebateSetupConfig(groupRebateSetupConfig => groupRebateSetupConfig = res['data']['GroupRebateSetupConfig']);
                setGroupRebateSetupLists(groupRebateSetupLists => groupRebateSetupLists = {
                    active: activeList,
                    billingrateid: res['data']['BillingRateList'],
                    producttypeid: res['data']['ProductTypeList'],
                    feecategoryid: res['data']['FeeCategoryList'],
                    rebatesetuptypeid: res['data']['RebateSetupTypeList']
                });
                // hide spinner
                setShowSpinner(showSpinner => showSpinner = false);
                // resolve on success
                resolve(res);
            }).catch(err => {
                // hide spinner
                setShowSpinner(showSpinner => showSpinner = false);
                // reject on error 
                reject(err);
            });
        });
    }

    // useEffect to run on intial render
    useEffect(() => {
        // determine submit rights if user is Admin or Data Tech 
        if (getAdmin() || getDataTech()) {
            setEditButtonBool(editButtonBool => editButtonBool = true);
        }
        else {
            setEditButtonBool(editButtonBool => editButtonBool = false);
        }
        // get data to display on page
        getAddConsortiumIdData().then(res => {
            console.log(res);
        }).catch(err => {
            console.log(err);
        });
    }, []);

    // useEffect to update showGroupSetupDataList when groupSetupDataList is updated
    useEffect(() => {
        if (addGroup) {
            setShowGroupSetupDataList(showGroupSetupDataList => showGroupSetupDataList = groupSetupDataList);
        }
    }, [groupSetupDataList]);

    // useEffect to update showGroupDataList when groupDataList is updated 
    useEffect(() => {
        if (addGroup) {
            setShowGroupDataList(showGroupDataList => showGroupDataList = groupDataList);
        }
    }, [groupDataList]);

    // useEffect to update visible group setups 
    useEffect(() => {
        // update data grid when add group is changed 
        if (addGroup) {
            setShowGroupSetupDataList(showGroupSetupDataList => showGroupSetupDataList = groupSetupDataList);
            setShowGroupDataList(showGroupDataList => showGroupDataList = groupDataList);
        }
        else {
            setShowGroupSetupDataList(showGroupSetupDataList => showGroupSetupDataList = dummySetupDataList);
            setShowGroupDataList(showGroupDataList => showGroupDataList = dummyDataList);
        }
    }, [addGroup]);

    // useEffect to automatically check add group if group payment type is chosen
    useEffect(() => {
        if (payoutType && parseInt(payoutType['grouprequired']) == 1) {
            setAddGroup(addGroup => addGroup = true);
        }
    }, [payoutType]);

    // useEffect to filter Rebate Component Config on Incentive ID change 
    useEffect(() => {
        if (initialRender1.current == false && portfolioId && portfolioId['id']) {
            // specify function list for filters
            const functionList = [
                { function: standardFilter, value: portfolioId['id'], flag: 1, cols: ['incentiveid'] }
            ];
            // use applyFilters function to search by running all functions declared above
            let filteredList = applyFilters(fullRebateComponentConfig, functionList);
            // update rebate config 
            setRebateComponentConfig(rebateComponentConfig => rebateComponentConfig = filteredList);
        }
        else {
            initialRender1.current = false;
        }
    }, [portfolioId])

    // variable for context
    const settings = {
        groupDataList,
        setGroupDataList,
        groupDateListLength,
        setGroupDataListLength,
        achAccountTypeList,
        setAchAccountTypeList,
        payoutMethodList,
        setPayoutMethodList,
        showSnackbar,
        setShowSnackbar,
        snackbarMessage,
        snackbarColor,
        addGroup,
        consortiumGroupErrorList,
        rebateSetupDataList,
        setRebateSetupDataList,
        rebateSetupDataListLength,
        setRebateSetupDataListLength,
        rebateSetupErrorList,
        setRebateSetupErrorList,
        feeCategoryList,
        setFeeCategoryList,
        productTypeList,
        setProductTypeList,
        billingRateList,
        setBillingRateList,
        rebateInputTypeId,
        groupSetupDataList,
        setGroupSetupDataList,
        groupSetupDataListLength,
        setGroupSetupDataListLength,
        groupSetupErrorList,
        setGroupSetupErrorList,
        rebateSetupTypeList,
        setRebateSetupTypeList,
        activeList
    }

    // return JSX
    return (
        <div class='summary-page'>
            {/* Wrap all children so they can access PageContext variables */}
            <PageContext.Provider value={settings}>
                {/* header and navslider present on every page */}
                <HeaderBanner indicator={1} />
                {/* breadcrumbs */}
                <div className="pt-1 ps-3 ms-3">
                    <PageBreadcrumbs />
                </div>
                <br />
                {/* snackbar component for alerts */}
                <SnackbarAlert />
                <div className="container-fluid d-flex flex-column">
                    <div className="d-flex flex-column flex-grow-1 p-2">
                        {/* link button to navigate to add new company profile */}
                        <div className="mb-3" style={{ borderRadius: '12px', background: '#fff' }}>
                            <div className='d-flex justify-content-between flex-wrap p-3'>
                                <div className='d-flex'>
                                    <Typography className='align-self-center'>Add New</Typography>
                                    {process.env.REACT_APP_CONSORTIUM_MANAGEMENT == '1' ? <div>
                                        <Link
                                            to={{
                                                pathname: "/AddNewCompanyProfilePage",
                                            }}
                                        >
                                            <ButtonComponent
                                                tag={"Company Profile"}
                                                border={'#000 1px solid'}
                                                background={window.location.pathname === '/AddNewCompanyProfilePage' ? '#000' : '#fff'}
                                                color={window.location.pathname === '/AddNewCompanyProfilePage' ? '#fff' : '#001317'}
                                                width={'150px'}
                                            />
                                        </Link>
                                    </div> : <></>}
                                    <div>
                                        <Link
                                            to={{
                                                pathname: "/AddConsortiumIdPage",
                                            }}
                                        >
                                            <ButtonComponent
                                                tag={"Consortium ID"}
                                                border={'#000 1px solid'}
                                                background={window.location.pathname === '/AddConsortiumIdPage' ? '#000' : '#fff'}
                                                color={window.location.pathname === '/AddConsortiumIdPage' ? '#fff' : '#001317'}
                                                width={'150px'}
                                            />
                                        </Link>
                                    </div>

                                </div>
                            </div>
                            <hr style={{ margin: 0 }} />
                            {/* top label to input company info */}
                            <div className='d-flex gap-1 align-items-center p-3'>
                                <div className='pe-3' >
                                    <PageInput tag='Consortium ID' value={consortium} setValue={setConsortium} showError={consortiumIdError} width={'12rem'} />
                                </div>
                                <div className='pe-3' >
                                    <PageDropdown tag='Consortium Type' obj={portfolioId} setObj={setPortfolioId} list={portfolioIdList} showError={portfolioIdError} />
                                </div>
                                <div className='pe-3' >
                                    <PageDropdown tag='Payout Type' obj={payoutType} setObj={setPayoutType} list={payoutTypeList} showError={payoutTypeError} />
                                </div>
                                <div>
                                    {showSpinner || isLoading ?
                                        <ButtonComponent border={'#fcd800 1px solid'} background={'#fcd800'} color={'#001317'}
                                            tag={<CircularProgress size='25px' sx={{ color: 'white', margin: '2.5px' }} />} />
                                        : editButtonBool && <ButtonComponent tag='Submit' border={'#fcd800 1px solid'} background={'#fcd800'} color={'#001317'} onButtonClick={() => onSubmitClick()} />}
                                </div>
                            </div>

                        </div>
                        {/* add consortium rebate setups */}
                        <div className="mb-3 pb-3" style={{ borderRadius: '12px', background: '#fff' }}>
                            <Typography className="mb-3 ps-3 pt-3">Consortium Rebate Setups</Typography>
                            <InputDataTable RowComponent={RebateSetupRowComponent} tableHeader={rebateSetupTableHeader} dataList={rebateSetupDataList} showSpinner={showSpinner} skeletonHeight='7vh' />
                        </div>
                        {/* add consortium rebate components */}
                        <div className="mb-3 pb-3" style={{ borderRadius: '12px', background: '#fff' }}>
                            <RebateComponentInput tag='Consortium Rebate Components' values={consortiumRebateComponents} setValues={setConsortiumRebateComponents} config={rebateComponentConfig} errorList={consortiumRebateComponentErrorList[0]} portfolioId={portfolioId} />
                        </div>
                        {/* table to add consortium group */}
                        <div className="mb-3 pb-3" style={{ borderRadius: '12px', background: '#fff' }}>
                            <div className="d-flex mb-3 ps-3 pt-3">
                                <Typography className="me-3 align-self-center">Group</Typography>
                                <div className="vr me-3 align-self-center" style={{ height: '1.5rem' }}></div>
                                <div className="d-flex flex-grow-1">
                                    <div>
                                        <FormControlLabel
                                            value="end"
                                            control={<Checkbox
                                                sx={{
                                                    color: '#000000',
                                                    '&.Mui-checked': {
                                                        color: '#000000',
                                                        fontFamily:'Roboto medium'
                                                    },
                                                }} />}
                                            label="Add Group"
                                            labelPlacement="end"
                                            sx={{
                                                // color: 'black',
                                                // margin: 'auto', 
                                                fontFamily:'Roboto medium'
                                            }}
                                            checked={addGroup}
                                            onChange={(e) => { setAddGroup(addGroup => addGroup = e.target.checked) }}
                                        />
                                    </div>
                                    <div class='label-text-span-right'>
                                        <text style={{ color: 'transparent' }}>---</text>
                                    </div>
                                </div>
                            </div>


                            <InputDataTable RowComponent={GroupRowComponent} tableHeader={groupTableHeader} dataList={showGroupDataList} showSpinner={showSpinner} skeletonHeight='7vh' />
                        </div>
                        {/* add group rebate setups */}
                        <div className="mb-3 pb-3" style={{ borderRadius: '12px', background: '#fff' }}>
                            <Typography className="mb-3 ps-3 pt-3">Group Rebate Setups</Typography>
                            <InputDataTable RowComponent={GroupSetupRowComponent} tableHeader={groupSetupTableHeader} dataList={showGroupSetupDataList} showSpinner={showSpinner} skeletonHeight='7vh' overrideMessage={true} />
                        </div>
                        {/* add group rebate components */}
                        {addGroup ? <div className="mb-3 pb-3" style={{ borderRadius: '12px', background: '#fff' }}>
                            <RebateComponentInput tag='Group Rebate Components' values={groupRebateComponents} setValues={setGroupRebateComponents} config={rebateComponentConfig} errorList={groupRebateComponentErrorList[0]} portfolioId={portfolioId} showOverride={addGroup} />
                        </div> : null}
                    </div>
                </div>
                <Footer cssClassName="footer-main-comp" />
            </PageContext.Provider>
        </div>
    );
}

export default ConsortiumManagementPage; 